






























































































































































































import Vue from 'vue';
import { FullscreenWrapper } from '@/components/fullscreen-wrapper-components';
import store from '@/store';
import { LoadingService } from '@/services';
import {
  HistoryTransactionResponseModel,
  SelectOption,
} from '@/@types/member';

interface Data {
  attachToATransaction: boolean;
  accountSelect: SelectOption;
  search: string;
  selectedTransaction: SelectOption;
}

export default Vue.extend({
  name: 'DocumentDetail',
  beforeRouteEnter: (to, from, next) => {
    LoadingService.watchPromises([
      store.dispatch('getDocuments'),
      store.dispatch('getAccounts'),
      store.dispatch('getTransactionHistory'),
    ])
      .then(next)
      .catch(() => {});
  },
  data() {
    return {
      attachToATransaction: false,
      accountSelect: null,
      search: '',
      selectedTransaction: [],
    };
  },
  computed: {
    // TODO add type
    document(): any {
      return this.$store.getters.getDocumentByID(this.$route.params.documentID);
    },
    accounts(): SelectOption[] {
      if (this.attachToATransaction) {
        return this.constructAccountSelect(this.$store.getters.accounts);
      }
    },
    transactions(): HistoryTransactionResponseModel[] {
      return this.$store.getters.transactionsByAccount(this.accountSelect);
    },
  },
  methods: {
    constructAccountSelect(accounts) {
      const accountsArray = [];

      accounts.forEach((account) => {
        accountsArray.push({
          text: account.name,
          value: account.id,
        });
      });

      return accountsArray;
    },
  },
  components: {
    FullscreenWrapper,
  },
});
